/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Location/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function Location({
  children,
  viewPath = "/App/ChooseLocation/Support/Locations/Content/Location",
  isSubmitting
  
}) {
let selectedIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'selected',
})
let selectedLocationIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'location_id',
})
let locationOrganizationIdValueData = fromData.useDataValue({ viewPath,
context: 'location',
path: 'organization_id',
})
let aggregateData = fromAggregate.equals(selectedLocationIdValueData, locationOrganizationIdValueData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSubmitting
  
})
let locationOrganizationNameValueData = fromData.useDataValue({ viewPath,
context: 'location',
path: 'organization_name',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 marginTop={dtSpaceXxs}
 marginRight={dtSpaceXxs}
 onClick={onClick}
 data="selected"
 disabled={selectedIsSubmittingData}
 type={aggregateData ? "primary" : "secondary"}
 data="selected.location_id"
 data="location.organization_id"
 aggregate="/Data/aggregate.js equals"
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 data="location.organization_name"
 text={locationOrganizationNameValueData}
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}